var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from 'classnames';
import * as React from 'react';
import { tupleNum } from '../_util/type';
import warning from '../_util/warning';
import Base from './Base';
const TITLE_ELE_LIST = tupleNum(1, 2, 3, 4, 5, 6);
const Title = (props, ref) => {
    const { block = true, level = 1, version = 1, className } = props, restProps = __rest(props, ["block", "level", "version", "className"]);
    let component;
    if (TITLE_ELE_LIST.indexOf(level) !== -1) {
        component = block ? `div` : `span`;
    }
    else {
        warning(false, 'Typography.Title', 'Title only accept `1 | 2 | 3 | 4 | 5` as `level` value. And `5` need 4.6.0+ version.');
        component = block ? `div` : `span`;
    }
    return (React.createElement(Base, Object.assign({ ref: ref }, restProps, { className: classNames({
            [`typography-title-${level}`]: version === 1,
            [`typography-title-v2`]: version === 2,
        }, className), component: component })));
};
export default React.forwardRef(Title);
